export default {
  methods: {
    closed () {
      this.$emit('closed')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/modal.js